import Vue from 'vue';
import { api } from "../../services/Api.js";

export function approve_news_item({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);

    
   

    // make api call
    return api
    .post(school,"approve_news_item.php",payload)
    .then( result =>{ 
      //done
      Vue.$toaster.toast("language.done");
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: aprove_news_item: "+error);
      return error;
    })

   

  }